// The device record stores the model a box registered with ('2500i', '510'); the live stream and the alarms spell
// it 'DM2500i' / 'DM510'. One place turns either into the name shown to people, and one test tells a DM510 apart.
export const normalizeModel = (model) =>
  String(model || '')
    .trim()
    .toLowerCase()
    .replace(/^dm/, '');

export const isDM510 = (model) => normalizeModel(model) === '510';

export const modelLabel = (model) => {
  const m = normalizeModel(model);
  if (!m) return '';
  if (m === '510') return 'DM510';
  if (m === '2500i') return 'DM2500i';
  return String(model);
};
